import { render, staticRenderFns } from "./TextWithValue.vue?vue&type=template&id=08993aee&functional=true&"
import script from "./TextWithValue.vue?vue&type=script&lang=ts&"
export * from "./TextWithValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports